module.exports = __webpack_public_path__ + "static/media/medical-schedule.9725ef78.svg";